module.exports = __webpack_public_path__ + "static/media/m1_sf_4.70f78132.png";